// 스니펫 참조를 재귀적으로 확장하는 순수 로직.
// API 조회는 호출자가 fetchSnippet으로 주입하고, 화면별 장식도 콜백으로 분리한다.
const SNIPPET_PATTERN = /\{\{%\s*snippet\s+(.*?)%\}\}/g
const DEFAULT_MAX_DEPTH = 20

function parseSnippetArgs(argStr) {
    const tokens = String(argStr || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
    const args = {}

    if (tokens.length === 0) return args

    if (!tokens[0].includes('=')) {
        args.code = tokens[0]
        tokens.shift()
    }

    if (tokens.length && !tokens[0].includes('=')) {
        const version = parseInt(tokens[0], 10)
        if (!isNaN(version)) args.version = version
        tokens.shift()
    }

    return args
}

function defaultRenderSnippet({ innerHtml }) {
    return innerHtml
}

function defaultRenderError({ token }) {
    return token
}

async function expandSnippetRefs(text, options, depth) {
    const input = String(text == null ? '' : text)
    const config = options || {}
    const currentDepth = depth == null ? 0 : depth
    const maxDepth =
        config.maxDepth == null
            ? DEFAULT_MAX_DEPTH
            : config.maxDepth

    if (typeof config.fetchSnippet !== 'function') {
        throw new Error('fetchSnippet 함수가 필요합니다.')
    }

    if (currentDepth > maxDepth) return input

    const renderSnippet =
        config.renderSnippet || defaultRenderSnippet
    const renderError =
        config.renderError || defaultRenderError
    const pattern = new RegExp(SNIPPET_PATTERN.source, 'g')

    let output = ''
    let lastEnd = 0
    let match

    while ((match = pattern.exec(input)) !== null) {
        output += input.slice(lastEnd, match.index)

        const args = parseSnippetArgs(match[1])
        const code = args.code
        const version = args.version

        if (!code) {
            output += renderError({
                code: '',
                version: null,
                message: '잘못된 스니펫 구문',
                token: match[0],
            })
        } else {
            try {
                const content = await config.fetchSnippet(code, version)
                const innerHtml = await expandSnippetRefs(
                    content || '',
                    config,
                    currentDepth + 1
                )

                output += renderSnippet({
                    code,
                    version,
                    innerHtml,
                    token: match[0],
                })
            } catch (error) {
                output += renderError({
                    code,
                    version,
                    message: error.message || String(error),
                    token: match[0],
                })
            }
        }

        lastEnd = match.index + match[0].length
    }

    output += input.slice(lastEnd)
    return output
}

module.exports = {
    SNIPPET_PATTERN,
    DEFAULT_MAX_DEPTH,
    parseSnippetArgs,
    expandSnippetRefs,
}
